// extracted by mini-css-extract-plugin
export var card = "home-module--card--lASLA";
export var cardGrid = "home-module--card-grid--E8T1U";
export var textContainer = "home-module--text-container--iL0cb";